import styled from "styled-components";
import { Form } from "react-bootstrap";
import TextEditor from "../../modules/TextEditor";
import { useState } from "react";
import {
  ButtonComp,
  SelectComp2,
  ModalCompAdvanceUpdate,
} from "../../../../components";
import { useGetGroupsNamesQuery } from "../../../../store/admin/communicationSlice";
import Message from "../../../../components/MessageModal";
import {
  useGetCommunicationMessageRecipientTypesQuery,
  useGetCommunicationMessageSendingModesQuery,
  useGetAllMembersQuery,
} from "../../../../store/selectableSlice";
// import Select from "react-select";

const NewMessage = ({
  message,
  setMessage,
  formValues,
  formErrors = {},
  editorKey = 0,
  editingDraftId = null,
  sendMessage = () => {},
  updateForm = () => {},
  updateRecipients = () => {},
}) => {
  const { data: groupsData = {} } = useGetGroupsNamesQuery();
  const communication_groups = groupsData?.communication_groups || [];
  const { data: receiptTypes = [] } =
    useGetCommunicationMessageRecipientTypesQuery();
  const { data: sendingModes = {} } =
    useGetCommunicationMessageSendingModesQuery();
  const {
    data: allMembersRaw = [],
    isLoading: membersLoading,
  } = useGetAllMembersQuery();
  const [modalName, setModalName] = useState();

  const allMembers = (allMembersRaw || []).filter(
    (m) =>
      m != null &&
      m.member_id != null &&
      m.first_name != null &&
      m.last_name != null
  );

  const memberOptions = allMembers.map((m) => ({
    label: `${m.first_name} ${m.last_name}`.trim(),
    value: m.member_id,
  }));

  const selectedRecipients = (formValues.recipients || [])
    .map((r) => {
      const opt = memberOptions.find(
        (o) => String(o.value) === String(r.member_id)
      );
      return opt || null;
    })
    .filter(Boolean);

  const receipt_type_name =
    receiptTypes.find(({ id }) => String(id) === formValues.receipt_type_id)
      ?.name || "";

  const closeModal = () => {
    setModalName();
  };

  const procecessMessage = (endpoint) => {
    setModalName();
    sendMessage(endpoint);
  };

  const modalItems = [
    {
      name: "Save",
      component: (
        <Message
          title={"Save"}
          desc={"Save message as draft?"}
          onBack={closeModal}
          onProceed={() => procecessMessage("saveToDraft")}
        />
      ),
    },
    {
      name: "Send",
      component: (
        <Message
          title={"Send"}
          desc={"Save and send message?"}
          onBack={closeModal}
          onProceed={() => {
            procecessMessage("send");
          }}
        />
      ),
    },
  ];
  return (
    <Wrapper>
      {editingDraftId && (
        <div
          className="alert alert-info mb-3"
          style={{
            backgroundColor: "#e1ecfe",
            border: "1px solid var(--color-secondary)",
            color: "var(--color-secondary)",
            borderRadius: "5px",
          }}
        >
          <strong>Editing draft:</strong> You are editing a saved draft. After making changes, you can send or save as a new draft.
        </div>
      )}
      <div className="row gx-0 p-4 justify-content-between bg-white form-fields gap-4">
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold mb-2">
            Message title <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            value={formValues.header}
            onChange={(e) => updateForm(e)}
            name="header"
            type="input"
          ></Form.Control>
          {formErrors.header && (
            <small className="text-danger mt-2 d-block">
              {formErrors.header[0]}
            </small>
          )}
        </Form.Group>
        <div className="col-12 col-lg-5 mb-3">
          <Form.Group>
            <Form.Label className="fw-bold mb-2">
              Recipient type <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              name="receipt_type_id"
              value={formValues.receipt_type_id ? String(formValues.receipt_type_id) : ""}
              onChange={(e) => updateForm(e)}
            >
              <option value="">Select...</option>
              {receiptTypes.map((item, index) => (
                <option key={index} value={String(item.id)} className="">
                  {item.name}
                </option>
              ))}
            </Form.Select>
            {formErrors.receipt_type_id && (
              <small className="text-danger mt-2 d-block">
                {formErrors.receipt_type_id[0]}
              </small>
            )}
          </Form.Group>
        </div>
        {receipt_type_name !== "Individual" ? (
          <div className="col-12 col-lg-5 mb-3">
            <Form.Group>
              <Form.Label className="fw-bold mb-2">
                Group member <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="group_id"
                value={formValues.group_id ? String(formValues.group_id) : ""}
                onChange={(e) => updateForm(e)}
              >
                <option value={""} className="">
                  Select...
                </option>
                {communication_groups.map(({ id, name }, index) => {
                  return (
                    <option key={index} value={String(id)} className="">
                      {name}
                    </option>
                  );
                })}
              </Form.Select>
              {formErrors.group_id && (
                <small className="text-danger mt-2 d-block">
                  {formErrors.group_id[0]}
                </small>
              )}
            </Form.Group>
          </div>
        ) : (
          <div className="col-12 col-lg-5 mb-3">
            <SelectComp2
              labelText={"Recipient members"}
              LabelClassName={"fw-bold"}
              isMulti={true}
              required
              selectedOption={selectedRecipients}
              setSelectedOption={updateRecipients}
              arrayComp={memberOptions}
              placeholder={"Search and select members"}
              isSearchable={true}
              isLoading={membersLoading}
              noOptionsMessage={() => "No members found"}
              desc={"Select one or more members to receive this message."}
              errors={Array.isArray(formErrors.recipients) ? formErrors.recipients : []}
            />
          </div>
        )}
        <div className="col-12 col-lg-5 mb-3">
          <Form.Group>
            <Form.Label className="fw-bold mb-2">
              Sending mode <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              name="sending_mode"
              value={formValues.sending_mode}
              onChange={(e) => updateForm(e)}
            >
              <option value="">Select...</option>
              {Object.entries(sendingModes).map(([key, value]) => {
                return (
                  <option key={key} value={value} className="">
                    {key}
                  </option>
                );
              })}
            </Form.Select>
            {formErrors.sending_mode && (
              <small className="text-danger mt-2 d-block">
                {formErrors.sending_mode[0]}
              </small>
            )}
          </Form.Group>
        </div>
      </div>
      <div className="border-line"></div>
      <div className="mb-3">
        <Form.Label className="fw-bold mb-2">
          Message body <span className="text-danger">*</span>
        </Form.Label>
        <TextEditor
          key={editorKey}
          initialValue={message}
          handleContentChange={setMessage}
        />
        {formErrors.body && (
          <small className="text-danger mt-2 d-block">
            {formErrors.body[0]}
          </small>
        )}
      </div>
      <div className="mt-4 d-flex gap-4">
        <ButtonComp
          btnText={"Send"}
          btnClassName={"bg-primary1 py-2 px-2 text-white rounded"}
          type={"button"}
          onClick={() => setModalName("Send")}
        />
        <ButtonComp
          btnText={"Save as draft"}
          btnClassName={"p-2 save fw-bold"}
          ButtonInlineStyle={{}}
          type={"button"}
          onClick={() => setModalName("Save")}
        />
      </div>
      <ModalCompAdvanceUpdate
        centered={true}
        pageName={modalName}
        arrayComp={modalItems}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .form-fields {
    border-radius: 10px;
    margin-top: 4px;
  }
  select,
  .form-select,
  .form-control {
    background-color: #fafafa !important;
    border: 1px solid #a1a0a0 !important;
    border-radius: 5px;
    outline: none !important;
    display: block;
    width: 100%;
    padding: 0.5rem;
  }
  select:focus,
  .form-select {
    outline: none !important;
  }
  .border-line {
    border: 1px solid #e0e0e0;
    margin-block: 16px;
  }
  button {
    min-width: 200px;
    border-radius: 10px;
    border: 1px solid var(--color-primary);
  }
  button.save {
    color: var(--color-primary);
  }
`;

export default NewMessage;
